import {
  readCache,
  writeCache,
  type CacheVersion,
} from "~/services/storage/idbCache";
import { useAuthStore } from "~/stores/auth";

function getCustomerId(): string | null {
  const auth = useAuthStore();
  return auth.storeId ? String(auth.storeId) : null;
}

/**
 * Read a resource from the per-customer IDB cache. No network. Returns null
 * on miss / no storeId. Used by stores to hydrate Pinia state at init.
 *
 * Version-aware reconcile and refetch live in `~/services/repos/versionSync`;
 * `baseRepo` only owns the storage boundary.
 */
export async function readMirror<T>(resource: string): Promise<T | null> {
  const cid = getCustomerId();
  if (!cid) return null;
  return readCache<T>(cid, resource);
}

/**
 * Write fresh data into the per-customer IDB cache. `version` should match
 * the hash in the Firestore version doc for this resource (or null when
 * untracked / unknown). No-op when there's no storeId.
 */
export async function writeMirror<T>(
  resource: string,
  data: T,
  version: CacheVersion = null
): Promise<void> {
  const cid = getCustomerId();
  if (!cid) return;
  await writeCache(cid, resource, data, version);
}
